import Cookies from 'vue-cookies'
import $store from "@/state/store"

const accessToken = 'TID'
const locationID = 'LID'
const merchantID = 'MID'
const inventoryID = 'IID'
const shop = 'SHO'
const typeSale = 'TS'
const dataPermission = 'dataPermission'
const locationName = 'locationName'
const itemBarcode = 'itemBarcode'

//set access token khi login
export function setAccessToken(val) {
  return Cookies.set(accessToken, val) //expire time 1 day
}
// get access token để check đăng nhập
export function getAccessToken() {
  return Cookies.get(accessToken)
}
export function removeAccessToken() {
  return Cookies.remove(accessToken)
}
// get mã location hiện tại
export function getLocationID() {
  return Cookies.get(locationID)
}
export function setLocationID(val) {
  return Cookies.set(locationID, val)
}
export function removeLocationID() {
  return Cookies.remove(locationID)
}
export function getLocationName() {
  return JSON.parse(localStorage.getItem(locationName))?.name
}
// get mã merchant hiện tạie thâ
export function getMerchanIDCurrent() {
  return Cookies.get(merchantID)
}
export function setMerchanIDCurrent(val) {
  return Cookies.set(merchantID, val)
}
export function removeMerchanIDCurrent(val) {
  return Cookies.remove(merchantID, val)
}
export function getShop() {
  return Cookies.get(shop)
}
export function setShop(val) {
  return Cookies.set(shop, val)
}
export function removeShop(val) {
  return Cookies.remove(shop, val)
}
export function getInventoryIdCurrent() {
  return Cookies.get(inventoryID)
}
export function setInventoryIdCurrent(val) {
  return Cookies.set(inventoryID, val)
}
export function removeInventoryIdCurrent(val) {
  return Cookies.remove(inventoryID, val)
}
export function getDataPermission() {
  return JSON.parse(localStorage.getItem(dataPermission))
}
export function setTypeSale(val) {
  return Cookies.set(typeSale, val) //1: bán hàng theo serial, 0: bán hàng thường
}
export function getTypeSale() {
  return Cookies.get(typeSale)
}
export function removeTypeSale(val) {
  return Cookies.remove(typeSale, val)
}
export function setRuleUser(val) {
  return JSON.parse(localStorage.setItem("auth.currentUser", val)).role
}
export function getRuleUser() {
  return JSON.parse(localStorage.getItem("auth.currentUser"))?.role
}
export function removeRuleUser() {
  return localStorage.removeItem('auth.currentUser')
}
export function setUserId(val) {
  return JSON.parse(localStorage.setItem("auth.currentUser", val)).userId
}
export function getUserId() {
  return JSON.parse(localStorage.getItem("auth.currentUser"))?.userId
}
export function removeUserId() {
  return localStorage.removeItem('auth.currentUser')
}
export function setUserName(val) {
  return JSON.parse(localStorage.setItem("auth.currentUser", val)).username
}
export function getUserName() {
  return JSON.parse(localStorage.getItem("auth.currentUser"))?.username
}
export function removeUserName() {
  return localStorage.removeItem('auth.currentUser')
}
export function setPhoneNumber(val) {
  return JSON.parse(localStorage.setItem("auth.currentUser", val)).phone
}
export function getPhoneNumber() {
  return JSON.parse(localStorage.getItem("auth.currentUser"))?.phone
}
export function removePhoneNumber() {
  return localStorage.removeItem('auth.currentUser')
}

export function getCurrentMerchant() {
  return JSON.parse(localStorage.getItem("auth.currentMerchant"))
}
export function setStorageItem(key, val) {
  localStorage.setItem(key, val)
}
export function getStorageItem(key) {
  return JSON.parse(localStorage.getItem(key))
}
export function removeStorageItem(key) {
  localStorage.removeItem(key)
}
export function getcurrentMerchantName() {
  return JSON.parse(localStorage.getItem("auth.currentUser"))?.name
}
export function setCookies(key, val) {
  Cookies.set(key, val)
}
export function storeCommit(key, val) {
  $store.commit(key, val)
}
export function getStorageItemNotParse(key) {
  return localStorage.getItem(key)
}
export function setItemBarcode(val) {
  localStorage.setItem(itemBarcode, JSON.stringify(val))
}
export function getItemBarcode() {
  return JSON.parse(localStorage.getItem(itemBarcode))
}
export function removeItemBarcode() {
  localStorage.removeItem(itemBarcode)
}